import React from 'react';
import { ProjectFieldsFragment } from '../../../../generated/core-api/graphql-react-query';

interface ProjectInfoContextType {
  project: ProjectFieldsFragment | null;
  projects: ProjectFieldsFragment[];
}

export const ProjectInfoContext = React.createContext<ProjectInfoContextType | null>(null);

export default function useProjectInfoContext() {
  const context = React.useContext(ProjectInfoContext);
  if (context === null) {
    throw new Error('useProjectInfoContext must be used within a ProjectInfoContextProvider');
  }
  return context;
}
